import React, { VFC } from 'react';

import { MessagesList } from '../components/MessagesList';

/** Inbox messages list page */
export const MessagesListPage: VFC = () => <MessagesList />;
